import { createFileRoute, Link } from "@tanstack/react-router";
import { RouteTopBar } from "@/components/layout/RouteTopBar";
import { LegalFooter } from "@/components/brand/LegalFooter";
import { LegalBody } from "@/components/legal/LegalBody";

export const Route = createFileRoute("/privacidad")({
  head: () => ({
    meta: [
      { title: "Política de Privacidad · VerseSport™" },
      { name: "description", content: "Política de Privacidad de VerseSport™ — datos, analytics y experiencias patrocinadas." },
    ],
  }),
  component: PrivacidadPage,
});

function PrivacidadPage() {
  return (
    <main className="min-h-screen bg-background">
      <RouteTopBar fallback="/welcome" />
      <article className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
        <header className="mb-6">
          <h1 className="text-3xl font-black text-foreground">Política de Privacidad</h1>
          <p className="mt-1 text-xs uppercase tracking-widest text-muted-foreground">
            Última actualización: {new Date().toLocaleDateString("es")}
          </p>
        </header>
        <LegalBody variant="privacy" />
        <p className="mt-8 text-xs text-muted-foreground">
          Administra tus preferencias en{" "}
          <Link to="/ajustes/privacidad" className="font-bold text-primary hover:underline">
            Configuración de privacidad
          </Link>
          .
        </p>
        <LegalFooter />
      </article>
    </main>
  );
}